<template>
  <div class="LOGISTICS_NUMBER">
    <Input
      class="LOGISTICS_NUMBER__input"
      :autocomplete="'new-password'"
      :disabled="isDisabled"
      v-model="valuedata"
      :placeholder="t('请在输入后按回车')"
      @on-blur="inputblur"
      @on-enter="inputenter"
    ></Input>
  </div>
</template>

<script>

export default {
  name: 'LOGISTICS_NUMBER',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      valuedata: '',
      isDisabled: false,
      ID: this.$route.params.itemId && this.$route.params.itemId != 'New' ? this.$route.params.itemId : '-1',
    };
  },
  mounted() {
    const val = this.$parent.$props.value;
    if (this.ID != '-1') {
      this.isDisabled = true
      this.valuedata = val
    }
  },
  methods: {
    inputenter() {
      console.log('enter::', this.valuedata);
      this.$emit('change', this.valuedata, this);
    },
    inputblur() { },
  },
};

</script>
